import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import ZonesTitleBar from './ZonesTitleBar'
import ZoneResidentsList from './ZoneResidentsList'
import AnimateHeight from 'react-animate-height'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'

export class ZonesItem extends React.Component {
  state = {
    deleteDialogOpen: false,
    isShowingContent: true,
  }

  handleDelete = () => {
    const {
      deleteSelf,
      onDelete,
      zone: { id },
    } = this.props
    deleteSelf({ id, onComplete: onDelete })
    this.setState({ deleteDialogOpen: false })
  }

  toggleOpen = () => {
    this.setState((prevState) => ({
      isShowingContent: !prevState.isShowingContent,
    }))
  }

  render() {
    const {
      onEdit,
      onEditResident,
      zone: { residents, name },
      preferredPeopleNominative,
    } = this.props
    const { isShowingContent } = this.state

    return (
      <div>
        <ZonesTitleBar
          isOpen={isShowingContent}
          onDelete={() => this.setState({ deleteDialogOpen: true })}
          onEdit={onEdit}
          title={name}
          toggleOpen={this.toggleOpen}
        />
        <AnimateHeight
          animateOpacity
          duration={500}
          height={isShowingContent ? 'auto' : 0}
        >
          <ZoneResidentsList
            onEditResident={onEditResident}
            residents={residents}
            preferredPeopleNominative={preferredPeopleNominative}
          />
        </AnimateHeight>
        <ConfirmationDialog
          isOpen={this.state.deleteDialogOpen}
          onCancel={() => this.setState({ deleteDialogOpen: false })}
          onConfirmation={this.handleDelete}
          confirmationType="warning"
        >
          <div>{CONFIRM_DELETE_MESSAGE}</div>
        </ConfirmationDialog>
      </div>
    )
  }
}

const CONFIRM_DELETE_MESSAGE =
  "Are you sure you want to delete this zone? Once it's gone, it's gone for good!"

ZonesItem.propTypes = {
  deleteSelf: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onEditResident: PropTypes.func.isRequired,
  zone: PropTypes.object.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteSelf: ({ id, onComplete }) =>
      dispatch(
        Operations.deleteFormItem({
          id,
          list: 'zones',
          onComplete,
        })
      ),
  }
}

export default connect(null, mapDispatchToProps)(ZonesItem)
